
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import DefaultBackdrop from './default-backdrop';
import DefaultDialog from './default-dialog';
import { useEffect } from 'react';
import DefaultMessage from './default-message';
import ApplicationAppService from '../application/platform/application-app-service';
import { BaseLayoutProvider } from './context/base-layout-context';
import { useBaseLayoutController } from './context/base-layout-controller';
import theme from '../theme/theme';

function BaseLayoutContent({ children }: { children: React.ReactNode }) {
    const applicationData = ApplicationAppService.getApplicationData();
    const { dialogProps, messageProps, loadingProps, showMessage, showLoading } = useBaseLayoutController();

    useEffect(() => {
        document.title = applicationData.moduleName;
    }, [applicationData.moduleName]);

    return (
        <ThemeProvider theme={theme}>
            <Box sx={{ display: 'flex' }}>
                <CssBaseline />
                <DefaultBackdrop {...loadingProps}></DefaultBackdrop>
                <DefaultMessage {...messageProps}></DefaultMessage>
                <DefaultDialog {...dialogProps}></DefaultDialog>
                {children}
            </Box>
        </ThemeProvider>
    );
}

export default function BaseLayout({ children }: { children: React.ReactNode }) {
    return (
        <BaseLayoutProvider>
            <BaseLayoutContent>
                {children}
            </BaseLayoutContent>
        </BaseLayoutProvider>
    );
}